// app/javascript/controllers/dae20/checklist_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  toggle(event) {
    const index = event.params.index
    const checkbox = event.target
    const label = checkbox.parentElement?.querySelector("span")
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    // Optimistic UI: toggle strikethrough immediately
    if (label) {
      if (checkbox.checked) {
        label.classList.add("line-through", "text-gray-400", "text-slate-400")
      } else {
        label.classList.remove("line-through", "text-gray-400", "text-slate-400")
      }
    }

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({ index: index })
    }).then(response => {
      if (!response.ok) {
        // revert on error
        checkbox.checked = !checkbox.checked
        if (label) {
          label.classList.toggle("line-through")
          label.classList.toggle("text-gray-400")
          label.classList.toggle("text-slate-400")
        }
      }
    }).catch(() => {
      checkbox.checked = !checkbox.checked
      if (label) {
        label.classList.toggle("line-through")
        label.classList.toggle("text-gray-400")
        label.classList.toggle("text-slate-400")
      }
    })
  }
}
